import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { initPageReveal } from '@/views/composables/useReveal.js'
import '@/style/index.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 全局兜底:每次路由切换后,自动扫描当前页面所有 reveal 元素并接上滚动入场动画
router.afterEach(() => {
  Vue.nextTick(() => initPageReveal(document.body))
})

new Vue({
  router,
  mounted () {
    // 首次加载也跑一遍,避免 SSR 阶段错过初始 DOM
    initPageReveal(document.body)
  },
  render: h => h(App)
}).$mount('#app')
